<div class="relative w-full z-[10]">
    <input 
        #dateInput 
        type="text" 
        [placeholder]="placeholder" 
        [disabled]="isDisabled" 
        [ngClass]="[
          baseClasses, 
          cssClass,
          isDisabled ? 'opacity-50 cursor-not-allowed bg-gray-100' : 'bg-white cursor-pointer opacity-100'
        ]" 
    />

    <!-- Icon Container -->
    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400"
        [class.opacity-50]="isDisabled">

        <!-- If mode is 'time', show the clock icon -->
        <svg *ngIf="mode === 'time'; else dateIcon" class="w-5 h-5" fill="none" stroke="currentColor"
            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>

        <!-- Otherwise (for 'date', 'datetime', and 'range' modes), show the calendar icon -->
        <ng-template #dateIcon>
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
        </ng-template>

    </div>
</div>


<!--1. Date range -->
 
<!-- <app-date-time-picker 
  formControlName="scheduledAt" 
  mode="range" 
  [cssClass]="'py-4 px-4 mt-2 text-base font-semibold text-primary_Text_Color'"
  [minDate]="minDate" 
  [isDisabled]="isDisabled"
  placeholder="Select a date range"
  (dateSelected)="onDateRangeSelected($event)">
</app-date-time-picker> -->

<!-- 2. Date Picker (Single Date) -->
 
 <!-- <app-date-time-picker 
  formControlName="scheduledDate" 
  mode="date" 
  [cssClass]="'py-4 px-4 mt-2 text-base font-semibold text-primary_Text_Color'"
  [minDate]="minDate" 
  [isDisabled]="isDisabled"
  placeholder="Select a date"
  (dateSelected)="onDateSelected($event)">
</app-date-time-picker> -->

<!-- 3. Date & Time Picker -->

 <!-- <app-date-time-picker 
  formControlName="scheduledDateTime" 
  mode="datetime" 
  [cssClass]="'py-4 px-4 mt-2 text-base font-semibold text-primary_Text_Color'"
  [minDate]="minDate" 
  [isDisabled]="isDisabled"
  placeholder="Select date and time"
  (dateSelected)="onDateTimeSelected($event)">
</app-date-time-picker> -->

<!-- 3. Time Picker (Time Only) -->

<!-- <app-date-time-picker 
  formControlName="scheduledTime" 
  mode="time" 
  [cssClass]="'py-4 px-4 mt-2 text-base font-semibold text-primary_Text_Color'"
  [isDisabled]="isDisabled"
  placeholder="Select a time"
  (dateSelected)="onTimeSelected($event)">
</app-date-time-picker> -->



<!-- Disable fields: 
 Programmtically cuz using reactive forms,For refrence you can add in html.
this.addScheduleDriveForm.get('scheduledAt').disable(); 
-->
